const students = {
  edit: {
    tabs: {
      information: 'Information',
      notes: 'Hinweise',
      parents: 'Eltern',
      caregivers: 'Pflegekräfte',
      history: 'Geschichte',
      bookingHistory: 'Buchungsverlauf'
    },
  },
  table: {
    headers: {
      createBtn: 'Erstellen',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      homeAddress: 'Privatadresse',
      alternateAddress: 'Alternative Adresse',
      schoolAddress: 'Schule',
      createdAt: 'Erstellt am',
    },
  },
  form: {
    header: {
      create: {
        title: 'Erstellen',
      },

      update: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    actions: {
      header: 'Aktionen',
      buttons: {
        resetPassword: 'Passwort zurücksetzen',
      },
    },

    create: {
      confirmButtonText: 'Einreichen',
      toasts: {
        success: 'Übergeordnetes Element erfolgreich erstellt',
        error: 'Beim Erstellen des übergeordneten Elements ist ein Fehler aufgetreten',
      },
    },
    update: {
      formTabs: {
        informationTab: 'Information',
        notesTab: 'Hinweise',
      },

      activeStatus: {
        statusActive: 'Aktiv',
        statusDeactivate: 'Inaktiv',
      },

      suspend: {
        actionActivate: 'Aufheben der Sperre',
        actionDeactivate: 'Sperren',
        suspendModal: {
          popupTitleDeactivation: 'Fahrgast sperren',
          popupTitleActive: 'Grund für die Sperrung',
          popupTitleUnsuspend: 'Grund für die Aufhebung der Sperrung',
          popupSubTitleDeactivation: 'Wählen Sie den Grund für die Sperrung aus',
          popupActionActive: 'Fahrgastsperrung aufheben',
          popupActionDeactivate: 'Fahrgast sperren',
        },
      },
      toasts: {
        success: 'Übergeordnetes Element erfolgreich aktualisiert',
        error: 'Beim Aktualisieren des übergeordneten Elements ist ein Fehler aufgetreten',
        fetchError: 'please try again.,Etwas ist schiefgelaufen, bitte versuchen Sie es erneut., please try again.',
      },
    },
    sections: {
      profiles: {
        fields: {
          label: 'Profil'
        }
      },
      attributes: {
        fields: {
          label: 'Profil'
        }
      },
      personalDetails: {
        header: 'Persönliche Daten',
        fields: {
          firstName: {
            label: 'Vorname',
          },
          lastName: {
            label: 'Nachname',
          },
          email: {
            label: 'E-Mail',
          },
          phone: {
            label: 'Telefon',
          },
          additionalPhone: {
            label: 'Zusätzliches Telefon',
          },
          gender: {
            label: 'Geschlecht',
          },
          dateBirth: {
            label: 'Geburtsdatum',
          },
        },
      },
      schoolDetails: {
        header: 'Schuldetails',
        fields: {
          school: {
            label: 'Schule',
          },
          academicYear: {
            label: 'Akademisches Jahr',
            options: {
              default: 'Standard',
              current: '2023-2024',
            },
          },
          level: {
            label: 'Ebene',
          },
          class: {
            label: 'Klasse',
          },
        },
      },
      profile: {
        header: 'Profil',
        fields: {
          profile: 'Profil',
        },
      },
      addresses: {
        header: 'Schüleradressen',
        fields: {
          mainAddress: {
            label: 'Hauptadresse',
          },
          alternateAddress: {
            label: 'Alternative Adresse',
          },
          level: {
            label: 'Ebene',
          },
          class: {
            label: 'Klasse',
          },
        },
      },
      linkParents: {
        linkedHeader: 'Verknüpfte Übergeordnete',
        listHeader: 'Liste mit Übergeordneten',
        noResultsLinkedTable: 'Noch keine Übergeordneten verknüpft',
        noResultsLinkedTableSubHeader: 'Fügen Sie Übergeordnete aus der Liste unten hinzu',
        noResultsListTable: 'Keine Übergeordnete  gefunden',
        noResultsListTableSubHeader: 'Wir können keinen Artikel finden, der Ihrer Suche entspricht',
        entity: 'Eltern',

        parentsTable: {
          headers: {
            name: 'Name',
            address: 'Adresse',
            phone: 'Telefon',
            email: 'E-Mail',
          },
        },
      },

      linkCaregivers: {
        linkedHeader: 'Verknüpfte Betreuer',
        listHeader: 'Liste der Betreuer',
        noResultsLinkedTable: 'Noch keine Betreuer verknüpft',
        noResultsLinkedTableSubHeader: 'Fügen Sie Betreuer aus der Liste unten hinzu',
        noResultsListTable: 'Keine Betreuer gefunden',
        noResultsListTableSubHeader: 'Wir können keinen Artikel finden, der Ihrer Suche entspricht',
        add: 'Hinzufügen',
        entity: 'Pflegekräfte',

        caregiversTable: {
          headers: {
            name: 'Name',
            address: 'Adresse',
            phone: 'Telefon',
            email: 'E-Mail',
          },
        },
      },
    },
  },
};

export default students;
